<template>
  <div
    class="-fragment"
    @click="previewAsset"
    @mouseenter="setHovering(true)"
    @mouseleave="setHovering(false)"
  >
    <div class="-inner">
      <div v-if="showActions && !overlay" class="-actions">
        <wt-asset-locate @locate="$emit('locate')" :asset="asset" />
        <wt-asset-remove @remove="$emit('remove')" />
        <wt-asset-transcribe
          v-if="isAssetCandidateForTranscribe"
          @transcribe="$_onEditTranscript"
        />
        <wt-asset-add :disabled="!canAdd" @add="$emit('add')" />
      </div>
      <img :src="mixinSrc(src)" :draggable="false" />
      <div class="-video-hover" v-if="hovering">
        <video
          playsinline
          disableRemotePlayback="true"
          :src="videoSrc"
          muted
          autoplay
          loop
          oncontextmenu="return false;"
        ></video>
      </div>
      <span v-if="!overlay" class="-play wticon wticon-play1" />
    </div>

    <div v-if="!overlay" class="-indicators">
      <transition name="wt2-fade-fast">
        <wt-asset-used v-if="isUsed" />
      </transition>
      <div v-if="transcribing" class="-transcribing">
        Transcribing<wt-ellipsis-animation />
      </div>
    </div>

    <wt-asset-icons-overlay-asset
      v-if="overlay"
      :duration="displayDuration"
      :icons="iconsForOverlayAsset"
    />
    <wt-asset-icons v-else :restrictions="assetRestrictions" :icons="icons" />
  </div>
</template>
<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetIconsForOverlayAsset from 'components/assets/mixins/AssetIconsForOverlayAsset.vue';
import AssetIcons from 'components/assets/mixins/AssetIcons.vue';
import ThumbnailTranscribeMixin from 'components/assets/mixins/thumbnailTranscribe.mixin';
import AssetTranscribe from '#/components/assets/mixins/AssetTranscribe.vue';

export default {
  // language=Vue
  mixins: [AssetMixins, ThumbnailTranscribeMixin],
  data: function () {
    return {
      hovering: false,
    };
  },
  components: {
    'wt-asset-icons-overlay-asset': AssetIconsForOverlayAsset,
    'wt-asset-icons': AssetIcons,
    'wt-asset-transcribe': AssetTranscribe,
  },
  computed: {
    src: function () {
      return (
        this.asset.thumbnail ||
        this.asset.metadata.thumbnail256x144Url ||
        this.asset.metadata.thumbnail160x90Url ||
        this.asset.metadata.posterUrl
      );
    },
    videoSrc: function () {
      return (
        this.asset.previewResultData?.cdnUrl ||
        this.asset.metadata.urlCdn ||
        this.asset.metadata.providerLowResAssetUrl ||
        this.asset.metadata.providerHiResAssetUrl
      );
    },
  },
  methods: {
    setHovering(isHovering) {
      this.hovering = isHovering;
    },
  },
};
</script>
<style lang="scss">
.-fragment {
  .-transcribing {
    color: white;
    text-shadow: 0px 1px 4px $color-normal;
  }
  .-video-hover {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;

    video {
      object-fit: contain;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    }
  }
}
</style>
